import React from "react";
import styles from './PageWithSidebarStructure.module.scss';
import Main from "./components/main/Main";
import {Grid} from '@material-ui/core';

interface IPageWithSidebarStructureProps {
  navigation?: any;
  children?: any;
  className?: string;
}

const PageWithSidebarStructure = (props: IPageWithSidebarStructureProps) => {
  return (
    <Grid container className={`controlContainer ${styles.controlContainer} ${props.className}`.trim()}>
      <section className={`hideWhenSignedIn767 rightSideSection ${styles.controlMenu}`}>
        {props.navigation}
      </section>
      <section className={`leftSideSection ${styles.controlList}`}>
        <Main>
          {props.children}
        </Main>
      </section>
    </Grid>
  );
};

PageWithSidebarStructure.defaultProps = {
  className: '',
};

export default PageWithSidebarStructure;
